import React, { Component } from 'react'
import { Button, Form, Grid, Header, Image, Message, Segment} from 'semantic-ui-react'
import { NavLink, Redirect } from 'react-router-dom'
import axios from 'axios';
import { Consumer } from '../../../../context/Context';
import SignInGoogleBase from './SignInGoogleBase'
import SignInFacebookBase from './SignInFacebookBase'
import SignInTwitterBase from './SignInTwitterBase'
import {MyStore} from '../../../../services/Store'


import firebase from 'firebase/app';
// import { withFirebase } from '../../../services';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            errors: {},
            isSignUp: false
        };



    }


    refreshPage() {
        window.location.reload(false);
      }
    onChange = e => this.setState({ [e.target.name]: e.target.value });

    onSubmit = async (dispatch, e) => {
        e.preventDefault();
        const { email, password, isSignUp } = this.state;
        if (email === '') {
            this.setState({ errors: { email: 'Email is required' } });
            return;
        }
        if (password === '') {
            this.setState({ errors: { password: 'Password is required' } });
            return;
        }

 


        // firebase.auth().signInWithEmailAndPassword(email, password).catch(function(error) {
        //     // Handle Errors here.
        //     var errorCode = error.code;
        //     var errorMessage = error.message;
        //     console.log(errorCode);
        //     console.log(errorMessage);
        // });

        const newUser = { email, password, returnSecureToken: true };
        let url = '';
        if (isSignUp) {
            url = `https://www.googleapis.com/identitytoolkit/v3/relyingparty/signupNewUser?key=AIzaSyByPyCA_FQBPRd27kOB9rBnfbQMTP0_U3o`;
        } else {
            url = `https://www.googleapis.com/identitytoolkit/v3/relyingparty/verifyPassword?key=AIzaSyByPyCA_FQBPRd27kOB9rBnfbQMTP0_U3o`;
        }
        let resp = null;
        let expDate = null;
        try {
            resp = await axios.post(url, newUser);
            expDate = new Date(new Date().getTime() + resp.data.expiresIn * 1000);
            localStorage.setItem('token', resp.data.idToken);
            localStorage.setItem('expDate', expDate);
            localStorage.setItem('userId', resp.data.localId);
            dispatch({
                type: 'AUTH_LOGIN',
                payload: { token: resp.data.idToken, localId: resp.data.localId }
            });

            console.log('-------------------- current user ----------------')
            MyStore.auth().signInWithEmailAndPassword(email, password)
            .catch(function(error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                console.log(errorCode);
                console.log(errorMessage);
            });
            // const user = MyStore.auth();
            // console.log('-------------------- current user ----------------')
            // console.log(user)
            // this.refreshPage()
        } catch (error) {   
            if (error.message === 'Request failed with status code 400') {
                this.setState({
                    errors: { response: 'User already exist, switch to Sign in' }
                });
            }
            if (
                !isSignUp &&
                error.message === 'Request failed with status code 400'
            ) {
                this.setState({
                    errors: { response: 'Invalid Email/Password' }
                });
            }
        }
        // const resp = await axios.post(url, newUser);
        if (resp) {
            // window.location.href = 'http://localhost:3000/';
            return <Redirect to='/' />;
        }
    };
    render() {
        const { errors, isSignUp } = this.state;
        return (
            <div >
                <Consumer>
                    {value => {
                        const { dispatch } = value;
                        return (
                            <Grid textAlign='center' style={{  minHeight: '80vh'}} verticalAlign='middle'>
                                <Grid.Column style={{ maxWidth: 450 }}>
                                    <Header as='h2' color='teal' textAlign='center'>
                                        <Image src='https://react.semantic-ui.com/logo.png' /> Log-in to your account
                                    </Header>
                                    <div
                                        className={isSignUp ? 'card-header bg-warning' : 'card-header bg-primary text-white'}>
                                        <h3 className={isSignUp ? 'float-left' : 'float-right'}>
                                            {isSignUp ? 'Sign Up' : 'Sign In'}
                                        </h3>
                                    </div>
                                        <Form size='large' onSubmit={e => this.onSubmit(dispatch, e)}>
                                            <Segment stacked  style={{
                                                                background: "transparent",
                                                                border: "1px solid transparent",
                                                                boxShadow: "none",
                                                                padding: "0em 0em",
                                            }} >
                                                <Form.Input fluid icon='user' iconPosition='left' placeholder='you@email.com'
                                                    name="email" value={this.state.email} onChange={this.onChange}
                                                    id="email" type="email"
                                                    className={'form-control form-control-lg ' + (errors.email ? 'is-invalid' : '')} />
                                                <div className="invalid-feedback">{errors.email}</div>
                                                <Form.Input fluid icon='lock' iconPosition='left' placeholder='Password' type='password' id="password" name="password"
                                                     value={this.state.password} onChange={this.onChange} 
                                                    className={'form-control form-control-lg ' +
                                                        (errors.password ? 'is-invalid' : '')}
                                                />
                                                <div className="invalid-feedback">{errors.password}</div>
                                                <div className="text-danger lead">
                                                    {errors.response ? errors.response : null}
                                                </div>
                                                {/* <Button color='teal' fluid size='large' onClick={this.onSubmitForm.bind(this)}> */}
                                                <Button color='teal' fluid size='large' onClick={this.loginUser}>
                                                    Login
                                            </Button>

                                            </Segment>
                                        </Form>

                                    <Message>
                                        New to us?
                                    <NavLink to="/register"> Sign Up </NavLink>
                                    </Message>


                                    {/* <SignInGoogleBase></SignInGoogleBase>
                                        <SignInFacebookBase></SignInFacebookBase>
                                        <SignInTwitterBase></SignInTwitterBase> */}

                               
                                </Grid.Column>
                            </Grid>
                        )
                    }}
                </Consumer>

            </div>
        );
    }
}


export default Login




// request = new Request('http://localhost:4300/auth/', {
//     method: 'POST',
//     headers: new Headers({
//     'Accept'       : 'application/json',
//     'Content-Type' : 'application/json',
//     }),
//     body: JSON.stringify({ user: data })
//     });

//     loginUser2 = () => {
//         e.preventDefault();

//         fetch(request).then(response => {
//         console.log(response);
//         const auth = response.headers.get('Authorization');
//         console.log(auth)
//         })
//     }